export default {
    closeMenu(state, payload) {
        state.menu.drawer = payload
    },
    openLoader(state, payload) {
        state.loader = payload
    },
    userData(state, payload) {
        state.userData = payload
    },
    userPermissions(state, payload) {
        state.userPermissions = payload
    },
}